import { DialogActions } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import RiskReviews from 'pages/Finance/Components/Financing/common/Risk';
import React from 'react';

const EvaluationsModule = (props: any) => {
  const { selectedRequest, setOpen } = props;
  const ImportedModuleLayout = (props: any) => {
    return (
      <div>
        {props.children}
        <DialogActions>
          <CustomButton
            onClick={() => setOpen(false)}
            color="secondary"
            style={{ marginTop: '10px' }}
          >
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    );
  };
  return (
    <ImportedModuleLayout>
      <RiskReviews
        item={selectedRequest}
        requestTypes={['confirming-request']}
      />
    </ImportedModuleLayout>
  );
};

export default EvaluationsModule;
